/* src/app/auth/tutorial/tutorial.component.scss */
ion-slides {
  height: 100%;
}
.swiper-slide {
  display: block;
}
.swiper-slide h2 {
  margin-top: 5vw;
}
.swiper-slide img {
  max-height: 50%;
  max-width: 80%;
  margin: 60px 0 40px;
  pointer-events: none;
}
b {
  font-weight: 500;
}
p {
  padding: 0 40px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ion-color-step-600, #60646b);
}
p b {
  color: var(--ion-text-color, #000000);
}
.swiper-pagination {
  width: 100%;
  bottom: 0;
}
.gif {
  background-image: url(/assets/images/tutorial.gif);
  width: 50vw;
  margin: auto;
  margin-top: 20vw;
  background-repeat: no-repeat;
  background-size: 36vw 79vw;
  border-radius: 50px;
  background-position: center center;
}
.phone {
  top: 0;
  height: 84vw;
  margin: 0 !important;
}
/*# sourceMappingURL=tutorial.component.css.map */
